export default "__VITE_ASSET__69e42276__"